export default __webpack_public_path__ + "static/media/trophy.d2a0f2db.svg";